import { useState, useEffect } from 'react';
import api from '../api/api';

export default function useFeaturedProjects(service) {
  const [featuredProjects, setFeaturedProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!service) return;

    const getProjects = async()=>{
    setLoading(true);
    let {data} = await api.get(`/project-briefs-by-service/${service}`)
    setFeaturedProjects(data.data)
    setLoading(false)
    }

    getProjects()
    }, [service]);

  return { featuredProjects, loading };
}